<h2 class="mb-2">
  <p id="list-document-utilisateur" class="titre2 m-4">
    {{ 'PROFIL_UTILISATEUR.DOCUMENT_TITRE_LIST_UTILISATEUR' | translate }}
  </p>
</h2>
@if (isLoading) {
  <div class="flex justify-center items-center h-64">
    <mat-spinner color="accent"></mat-spinner>
  </div>
}
@if (!isLoading) {
  <div class="flex items-end justify-end mt-4 mb-4 gap-3 px-3 mt-4">
    <input class="h-8 w-46 rounded-md border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200" type="text" [(ngModel)]="textRechercher" (ngModelChange)="filtre()"
      placeholder="{{ 'CONTENUS_MANAGEMENT.SEARCH' | translate }}...">
    </div>
    <div>
      <div class="w-full overflow-x-auto">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo" (matSortChange)="sortDataChange($event)">
          <ng-container matColumnDef="nomFichier">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2 w-1/4">{{ 'PROFIL_UTILISATEUR.DOCUMENT_COL_NOM' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b w-1/4">{{element.nomFichier |tiret}} </td>
          </ng-container>
          <ng-container matColumnDef="nomUtilisateur">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2 w-1/4">{{ 'PROFIL_UTILISATEUR.DOCUMENT_COL_NOM_UTILISATEUR' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b w-1/4"> {{ element.nomUtilisateur | tiret }} </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2 w-2/5">{{ 'PROFIL_UTILISATEUR.DOCUMENT_COL_DESRIPTION' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b w-1/4"> {{ element.description | tiret }} </td>
          </ng-container>
          <ng-container matColumnDef="extension">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2 w-1/12">{{ 'PROFIL_UTILISATEUR.DOCUMENT_COL_EXTENSION' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b w-1/4">
              @if (element.extension === '.pdf') {
                <mat-icon class="material-symbols-outlined">picture_as_pdf</mat-icon>
              }
              @if (element.extension !== '.pdf') {
                <mat-icon class="material-symbols-outlined">file_download</mat-icon>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef  class="px-2 py-1 text-center w-1/12"></th>
            <td mat-cell *matCellDef="let element" class="px-2 py-1 text-center w-1/12">
              <button (click)="visualiser(element)" mat-icon-button
                class="text-black-500 hover:text-red-700 transform scale-90 sm:scale-100">
                <mat-icon class="material-symbols-outlined">
                  visibility
                </mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
        </table>
        @if (dataSource.filteredData.length === 0) {
          <div class="text-center mt-2 text-gray-500">
            {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
          </div>
        }
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
          (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
        </mat-paginator>
      </div>
    </div>
  }
  <div class="flex justify-end px-3 mt-4">
    <a (click)="retour()">
      <button class="btn-secondary-novo">{{ 'PROFIL_UTILISATEUR.DOCUMENT_RETOUR' | translate }}</button>
    </a>
  </div>


